import { SpotLight } from "@react-three/drei";
// import { useHelper } from "@react-three/drei";
// import { PointLightHelper } from "three";
// import {  SpotLightHelper } from "three";
// import { DirectionalLightHelper } from "three";
// import { useRef } from "react";

const Light = ({ lights, isLightOn, isWallLightOn, settings }) => {
    // console.log("lights: ", lights);
    const intensity = isLightOn ? settings.mainIntensity : 0;
    const wallIntensity = isWallLightOn ? settings.wallIntensity : 0;

    // const light = useRef();

    // const light2 = useRef();

    // const light3 = useRef();
    // const light4 = useRef();
    // useHelper(light, SpotLightHelper, "red");
    // useHelper(light, DirectionalLightHelper, 0.1, "red");
    // useHelper(light2, DirectionalLightHelper, 0.1, "red");
    // useHelper(light3, DirectionalLightHelper, 0.1, "red");
    // useHelper(light4, DirectionalLightHelper, 0.1, "red");
    // useHelper(light, PointLightHelper, 0.1, "red");
    // useHelper(light2, PointLightHelper, 0.1, "red");
    // useHelper(light2, RectAreaLightHelper, "red");
    // useHelper(light3, RectAreaLightHelper, "red");

    return (
        <group>
            {lights.directionalLights.map(({ pos, intensity, shadow }, i) => (
                <directionalLight
                    key={i}
                    intensity={intensity}
                    color="white"
                    castShadow={shadow}
                    shadow-mapSize={1024}
                    position={pos}
                    // ref={i === 0 ? light : i === 1 ? light2 : i === 2 ? light3 : light4}
                />
            ))}

            {lights.shadowLights.map((position, i) => (
                <pointLight
                    // ref={light}
                    key={i}
                    intensity={intensity}
                    color={settings.mainColor}
                    position={position}
                    distance={7}
                    decay={0.2}
                    castShadow
                    shadow-mapSize={1024}
                    shadow-camera-near={0.1}
                    shadow-camera-far={5}
                />
            ))}

            {lights.mainLights.map(({ pos, power }, i) => (
                <pointLight
                    key={i}
                    intensity={intensity * power}
                    color={settings.mainColor}
                    position={pos}
                    distance={5 * power}
                    decay={0.2}
                    // ref={light}
                />
            ))}
            {lights.wallLights.map((position, i) => (
                <group key={i}>
                    <pointLight
                        // ref={light2}
                        intensity={wallIntensity}
                        color={settings.wallColor}
                        position={position}
                        distance={2}
                        // decay={2}
                    />

                    <SpotLight
                        // ref={light2}
                        castShadow={false}
                        intensity={wallIntensity * 3}
                        color={settings.wallColor}
                        position={[position[0], position[1] - 0.0, position[2]]}
                        distance={1.8}
                        angle={0.55}
                        penumbra={1}
                        decay={1.5}
                        target-position={[position[0], 2, position[2]]}
                        anglePower={Infinity}
                    />

                    <SpotLight
                        castShadow={false}
                        intensity={wallIntensity * 20}
                        color={settings.wallColor}
                        position={[position[0], position[1], position[2]]}
                        distance={0.3}
                        angle={0.7}
                        penumbra={0.5}
                        decay={2}
                        target-position={[position[0], 2, position[2]]}
                        anglePower={Infinity}
                    />
                    <SpotLight
                        // ref={light2}
                        intensity={wallIntensity * 3}
                        color={settings.wallColor}
                        position={[position[0], position[1] - 0.1, position[2]]}
                        distance={2.5}
                        angle={0.7}
                        penumbra={1}
                        decay={1}
                        castShadow={true}
                        shadow-mapSize={1024}
                        target-position={[position[0], -1, position[2]]}
                        anglePower={Infinity}
                    />
                    <SpotLight
                        castShadow={false}
                        intensity={wallIntensity * 20}
                        color={settings.wallColor}
                        position={[position[0], position[1], position[2]]}
                        distance={0.4}
                        angle={0.6}
                        penumbra={0.5}
                        decay={2}
                        target-position={[position[0], 0, position[2]]}
                        anglePower={Infinity}
                    />
                </group>
            ))}
        </group>
    );
};

export default Light;
